const ChartType = Object.freeze({
  BAR: 'bar',
  DONUT: 'donut',
  MOVED: 'moved',
  HORIZONTAL_BAR: 'Horizontal bar',
  HORIZONTAL_CHANGE: 'Horizontal change',
  HORIZONTAL_STACK: 'Horizontal stack',
  HORIZONTAL_STACK_PERCENTAGE: 'Horizontal stack %',
  MATRIX: 'Matrix',
  PIE: 'Pie',
  STACK: 'Stack',
  VERTICAL_BAR: 'Vertical bar',
  VERTICAL_STACK: 'Vertical stack',
});

export const ChartLabel = Object.freeze({
  [ChartType.BAR]: 'Bar',
  [ChartType.DONUT]: 'Donut',
  [ChartType.MOVED]: 'Moved',
  [ChartType.HORIZONTAL_BAR]: 'Bar',
  [ChartType.HORIZONTAL_CHANGE]: 'Change',
  [ChartType.HORIZONTAL_STACK]: 'Stack',
  [ChartType.HORIZONTAL_STACK_PERCENTAGE]: '% Stack',
  [ChartType.MATRIX]: 'Matrix',
  [ChartType.PIE]: 'Pie',
  [ChartType.STACK]: 'Stack',
  [ChartType.VERTICAL_BAR]: 'Bar',
  [ChartType.VERTICAL_STACK]: 'Stack',
});

export default ChartType;
